module.exports = __webpack_public_path__ + "img/VASOFONO.2c442d2a.png";